module.exports = __webpack_public_path__ + "img/card_layout_1.d1a21bbb.jpg";